import React, { useEffect, useRef, useCallback, useState, useImperativeHandle, forwardRef } from "react";

import axios from 'util/axios';

import ModalPortal from "util/component/Modal";
import { Modal, ConfirmWithMessage } from "util/component/Modal/Modal";
import { useSelector } from "react-redux";

import update from "immutability-helper";
import { useTranslation } from "react-i18next";

const SEARCHCONDITION_PROJ = {
    code: "",
};

const Selected = (props, ref) => {
    const TBL_DATA_REF = useRef([]);
    const TBL_DATA_ORIGIN = useRef([]);
    const [IS_ACCEPT, SetIS_ACCEPT] = useState(0);

    const { t } = useTranslation(["page"]);

    const [ShowModal, SetShowModal] = useState(false);
    const [ShowModal2, SetShowModal2] = useState(false);

    const ALL_CHECK = useRef(null);

    const userSelector = useSelector((store) => store.user);

    const [ProjList, SetProjList] = useState([]);

    const [SearchCondition, SetSearchCondition] = useState(SEARCHCONDITION_PROJ);

    useImperativeHandle(ref, () => ({
        addProject: (data) => {
            const newData = data.map((d) => ({ code: d.code }));
            TBL_DATA_ORIGIN.current = Array.from(new Set([...TBL_DATA_ORIGIN.current, ...newData]));
            TBL_DATA_REF.current = [...TBL_DATA_ORIGIN.current];
            SetIS_ACCEPT(2);
            SetSearchCondition((OLD) => ({ ...OLD, refresh: new Date().toString() }));
        },
    }));

    const getDataList = useCallback(async () => {
        SetIS_ACCEPT(0);
        let response;
        response = await axios
            .post(process.env.REACT_APP_API + "/user/retrieveProjectList", {
                userId: props.selectedUser?.userId,
            })
            .then((Response) => Response.data?.data?.result);
        TBL_DATA_ORIGIN.current = response || [];
        TBL_DATA_REF.current = [...TBL_DATA_ORIGIN.current];
        SetIS_ACCEPT(1);
        SetSearchCondition((OLD) => ({ ...OLD, refresh: new Date().toString() }));
    }, [props.selectedUser]);

    useEffect(() => {
        getDataList();
    }, [getDataList, props]);

    useEffect(() => {
        
        if (TBL_DATA_ORIGIN.current) {
            
            props.filterProject(TBL_DATA_ORIGIN.current);
        }
    }, [IS_ACCEPT,props]);

    const HandleSearchCondition = (element) => {
        const name = element.target.name;
        const value = element.target.value;
        SetSearchCondition((OLD) => ({ ...OLD, [name]: value }));
    };

    const inputDelayRef = useRef(null);

    useEffect(() => {
        clearTimeout(inputDelayRef.current);
        // inputDelayRef.current = setTimeout(() => {
        const { code } = SearchCondition;
        TBL_DATA_REF.current = TBL_DATA_ORIGIN.current;
        if (code) {
            if (code) {
                TBL_DATA_REF.current = TBL_DATA_REF.current.filter((f) => {
                    const regex = new RegExp("^" + code, "gi");
                    return f.code.match(regex);
                });
            }
        }
        SetProjList(TBL_DATA_REF.current);
    }, [SearchCondition]);

    const AllCheckFunc = (e) => {
        const check = e.target.checked;
        SetProjList((OLD) => OLD.map((e) => ({ ...e, checked: check })));
    };

    const HandleCheckbox = (checked, index) => {
        SetProjList((OLD) => {
            const NEW_DATA = update(OLD, {
                [index]: { $set: { ...OLD[index], checked: checked } },
            });
            const check = NEW_DATA.filter((f) => !f.checked);
            if (ALL_CHECK.current.checked && check.length > 0) {
                ALL_CHECK.current.checked = false;
            } else if (check.length < 1) {
                ALL_CHECK.current.checked = true;
            }
            return NEW_DATA;
        });
    };

    const DeleteProjList = () => {
        const deleteList = ProjList.filter((f) => f.checked);
        const New_Data = [...TBL_DATA_ORIGIN.current]?.filter((f) => {
            return !deleteList.find((ff) => ff.code === f.code);
        });
        TBL_DATA_ORIGIN.current = New_Data;
        SetIS_ACCEPT((OLD) => OLD + 2);
        SetSearchCondition((OLD) => ({ ...OLD, refresh: new Date() }));
    };

    const CHECKED = ProjList.length > 0 && ProjList.filter((f) => f.checked).length === ProjList.length;

    const HandleSave = async (message) => {
        const userId = props.selectedUser.userId;
        const createUserId = userSelector.userId;
        const projects = [...TBL_DATA_ORIGIN.current.map((d) => ({ projectNm: d.code }))];
        const postData = {
            userId,
            createUserId,
            projects,
            message,
        };
        const response = await axios
            .post(process.env.REACT_APP_API + "/user/createProject", postData)
            .then((Response) => Response);

        SetShowModal2(true);
        getDataList();
    };

    return (
        <>
            <div className={"userAuthExternalTable"} style={{ flex: "0 0 180px" }}>
                <div
                    style={{
                        width: "170px",
                    }}
                >
                    <table className={"bpl-table-default fixed has-pagination userAuthExternalTable-table seleced"}>
                        <colgroup>
                            <col width="40px" />
                            <col width="100px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Project</th>
                            </tr>
                            <tr>
                                <td>
                                    <input type="checkbox" ref={ALL_CHECK} checked={CHECKED} onChange={AllCheckFunc} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className={"bpl-input-default"}
                                        name={"code"}
                                        value={SearchCondition.code}
                                        placeholder={"Project"}
                                        onChange={HandleSearchCondition}
                                    />
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div
                    style={{
                        width: "170px",
                        minHeight: "350px",
                        height: "55vh",
                        overflowY: "auto",
                        overflowX: "hidden",
                    }}
                >
                    <table className={"bpl-table-default fixed has-pagination userAuthExternalTable-table seleced"}>
                        <colgroup>
                            <col width="40px" />
                            <col width="100px" />
                        </colgroup>
                        <tbody>
                            {ProjList?.map((rowData, index) => {
                                return (
                                    <tr
                                        key={`UserAuthExternalSelectedList${index}`}
                                        onClick={() => HandleCheckbox(!rowData.checked, index)}
                                    >
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={rowData.checked || false}
                                                onChange={({ target }) => HandleCheckbox(target.checked, index)}
                                            />
                                        </td>
                                        <td>{rowData.code}</td>
                                    </tr>
                                );
                            })}
                            {ProjList.length < 1 && (
                                <tr className={"non-clickable"}>
                                    <td colSpan={2}>No Projects</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        width: "170px",
                        height: "5vh",
                    }}
                >
                    <table className={"bpl-table-default fixed has-pagination userAuthExternalTable-table"}>
                        <colgroup>
                            <col width="40px" />
                            <col width="100px" />
                        </colgroup>
                        <tfoot>
                            {ProjList?.filter((f) => f.checked)?.length > 0 && (
                                <tr>
                                    <td colSpan={3}>
                                        <button className={"bpl-btn danger w-100 mt-2"} onClick={DeleteProjList}>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            )}
                            {IS_ACCEPT > 1 && (
                                <tr>
                                    <td colSpan={3}>
                                        <button className={"bpl-btn success w-100 mt-2"} onClick={() => SetShowModal(true)}>
                                            Accept
                                        </button>
                                    </td>
                                </tr>
                            )}
                        </tfoot>
                    </table>
                </div>
            </div>
            {ShowModal && (
                <ModalPortal>
                    <ConfirmWithMessage
                        onClose={() => SetShowModal(false)}
                        message={"Confirm message"}
                        onConfirm={(msg) => HandleSave(msg)}
                    ></ConfirmWithMessage>
                </ModalPortal>
            )}
            {ShowModal2 && (
                <ModalPortal>
                    <Modal onClose={() => SetShowModal2(false)}>
                        <p>{t("saved")}</p>
                    </Modal>
                </ModalPortal>
            )}
        </>
    );
};

export default forwardRef(Selected);
